import EditManagerForm from './EditManagerForm';

export default EditManagerForm;



// WEBPACK FOOTER //
// ./src/scenes/Managers/components/EditManagerForm/index.ts